/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

/**
 * Scopes
 */
const scopes = require('../../scopes');

module.exports = [
  {
    action: 'activateAccountsBySystemGameId',
    message: messages.SUCCESS_ACTIVATE_ACCOUNTS_BY_SYSTEM_GAME_ID,
    method: 'PATCH',
    path: '/accounts/:systemGameId/activate',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.ACTIVATE_ACCOUNT,
    requestSchema: requestSchemas.accounts.activateAccountsBySystemGameId,
  },
  {
    action: 'authorizeAccount',
    message: messages.SUCCESS_AUTHORIZE_ACCOUNT,
    method: 'POST',
    path: '/account/authorize',
    payloadType: 'resource',
    permissionIdentity: null,
    requestSchema: requestSchemas.accounts.authorizeAccount,
  },
  {
    action: 'deauthorizeAccount',
    message: messages.SUCCESS_DEAUTHORIZE_ACCOUNT,
    method: 'POST',
    path: '/account/deauthorize',
    payloadType: 'resource',
    permissionIdentity: null,
    requestSchema: requestSchemas.accounts.deauthorizeAccount,
  },
  {
    action: 'deactivateAccountsBySystemGameId',
    message: messages.SUCCESS_DEACTIVATE_ACCOUNTS_BY_SYSTEM_GAME_ID,
    method: 'PATCH',
    path: '/accounts/:systemGameId/deactivate',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.DEACTIVATE_ACCOUNT,
    requestSchema: requestSchemas.accounts.deactivateAccountsBySystemGameId,
  },
  {
    action: 'getAccountByUsername',
    message: messages.SUCCESS_GET_ACCOUNT_BY_USERNAME,
    method: 'GET',
    path: '/account/:username',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.GET_ACCOUNT,
    requestSchema: requestSchemas.accounts.getAccountByUsername,
  },
  {
    action: 'getAccountsBySystemGameId',
    message: messages.SUCCESS_GET_ACCOUNTS_BY_SYSTEM_GAME_ID,
    method: 'GET',
    path: '/accounts/:systemGameId',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.GET_ACCOUNT,
    requestSchema: requestSchemas.accounts.getAccountsBySystemGameId,
    scopes: [
      scopes.ACCOUNTS_DEACTIVATED,
      scopes.ACCOUNTS_REMOVED,
      scopes.DEFAULT,
    ],
  },
  {
    action: 'recoverAccountsBySystemGameId',
    message: messages.SUCCESS_RECOVER_ACCOUNTS_BY_SYSTEM_GAME_ID,
    method: 'PATCH',
    path: '/accounts/:systemGameId/recover',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.RECOVER_ACCOUNT,
    requestSchema: requestSchemas.accounts.recoverAccountsBySystemGameId,
  },
  {
    action: 'refreshAccountApiKeyById',
    message: messages.SUCCESS_REFRESH_ACCOUNT_API_KEY_BY_ID,
    method: 'PATCH',
    path: '/account/:objectId/api-key',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.REFRESH_ACCOUNT_API_KEY,
    requestSchema: requestSchemas.accounts.refreshAccountApiKeyById,
  },
  {
    action: 'refreshAccountOneTimePasswordSecretById',
    message: messages.SUCCESS_REFRESH_ACCOUNT_ONE_TIME_PASSWORD_SECRET_BY_ID,
    method: 'PATCH',
    path: '/account/:objectId/one-time-password-secret',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.REFRESH_ACCOUNT_ONE_TIME_PASSWORD_SECRET,
    requestSchema: requestSchemas.accounts.refreshAccountOneTimePasswordSecretById,
  },
  {
    action: 'removeAccountsBySystemGameId',
    message: messages.SUCCESS_REMOVE_ACCOUNTS_BY_SYSTEM_GAME_ID,
    method: 'PATCH',
    path: '/accounts/:systemGameId/remove',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.REMOVE_ACCOUNT,
    requestSchema: requestSchemas.accounts.removeAccountsBySystemGameId,
  },
  {
    action: 'updateAccountById',
    message: messages.SUCCESS_UPDATE_ACCOUNT_BY_ID,
    method: 'PATCH',
    path: '/account/:objectId',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.UPDATE_ACCOUNT,
    requestSchema: requestSchemas.accounts.updateAccountById,
  },
  {
    action: 'updateAccountPasswordById',
    message: messages.SUCCESS_UPDATE_ACCOUNT_PASSWORD_BY_ID,
    method: 'PATCH',
    path: '/account/:objectId/password',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.UPDATE_ACCOUNT_PASSWORD,
    requestSchema: requestSchemas.accounts.updateAccountPasswordById,
  },
  {
    action: 'updateAccountUsernameById',
    message: messages.SUCCESS_UPDATE_ACCOUNT_USERNAME_BY_ID,
    method: 'PATCH',
    path: '/account/:objectId/username',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.UPDATE_ACCOUNT_USERNAME,
    requestSchema: requestSchemas.accounts.updateAccountUsernameById,
  },
];
